import { useRouter } from "next/router";

export function usePaymentRequestId(requestId?: string | string[]) {
  const {
    query: { paymentRequestId: queryRequestId },
  } = useRouter();

  // use arg requestId if available, otherwise use queryRequestId.
  // if neither are present pass null to cancel the request.
  let paymentRequestId = null;

  if (queryRequestId) {
    paymentRequestId =
      typeof queryRequestId === "string" ? queryRequestId : queryRequestId[0];
  }

  if (requestId) {
    paymentRequestId = typeof requestId === "string" ? requestId : requestId[0];
  }
  return paymentRequestId as string;
}
